import { Trophy, Award } from 'lucide-react';

const formatScore = (s, scoringType) => {
  if (s == null) return '—';
  return scoringType === 'time' ? `${Number(s).toFixed(1)}s` : Math.round(s);
};

const RankRow = ({ row, scoringType, highlight }) => {
  const rank = row.rank;
  const isTop3 = rank <= 3;
  const isTop10 = rank <= 10;
  const medal = rank === 1 ? '🥇' : rank === 2 ? '🥈' : rank === 3 ? '🥉' : null;

  return (
    <div
      data-testid={`rank-row-${rank}`}
      className={`flex items-center gap-3 p-3 rounded-sm border transition-colors ${
        highlight || row.is_self
          ? 'bg-primary/10 border-primary/50'
          : isTop3
          ? 'bg-amber-500/5 border-amber-500/30'
          : isTop10
          ? 'bg-card border-primary/20'
          : 'bg-card border-border/40'
      }`}
    >
      <div className={`w-10 text-center font-heading text-lg ${isTop3 ? 'text-amber-300' : isTop10 ? 'text-primary' : 'text-muted-foreground'}`}>
        {medal || `#${rank}`}
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-medium text-sm truncate flex items-center gap-2">
          {row.athlete_name}
          {row.is_self && <span className="text-[10px] bg-primary/20 text-primary px-1.5 py-0.5 rounded uppercase tracking-widest">You</span>}
        </p>
        {row.club_name && <p className="text-xs text-muted-foreground truncate">{row.club_name}</p>}
      </div>
      <div className={`font-heading text-xl ${isTop3 ? 'text-amber-300' : 'text-primary'}`}>
        {formatScore(row.best_score, scoringType)}
      </div>
    </div>
  );
};

const RankingTable = ({ ranking, scoringType }) => {
  if (!ranking) return null;
  const rows = ranking.ranking || [];
  const myRanks = ranking.my_ranks || [];

  if (rows.length === 0) {
    return (
      <div className="bg-card border border-border rounded-sm p-12 text-center">
        <Trophy className="mx-auto text-muted-foreground mb-3" size={32} />
        <p className="text-muted-foreground text-sm">Be the first to set a score this week!</p>
      </div>
    );
  }

  return (
    <div className="space-y-2" data-testid="ranking-table">
      {rows.map((r) => (
        <RankRow key={r.athlete_id} row={r} scoringType={scoringType} />
      ))}
      {myRanks.length > 0 && (
        <>
          <div className="text-center text-xs text-muted-foreground uppercase tracking-widest py-3">···</div>
          {myRanks.map((r) => (
            <RankRow key={r.athlete_id} row={r} scoringType={scoringType} highlight />
          ))}
        </>
      )}
    </div>
  );
};

export default RankingTable;
